<template>
  <div class="container" id="cliente">
    <div class="titulo">
      <h1>{{ $t('message.clientes') }}</h1>
      <img class="img_line" src="./../../public/imgs/line.png" />
    </div>

    <div class="row">

    </div>
    <div class="row">
      <div class="col center">
        <img src="./../../public/imgs/logos/SunoAgencyLogo.png" class="img_logo_client" />
      </div>
      <div class="col center">
        <img src="./../../public/imgs/logos/WMcCannLogo.png" class="img_logo_client" />
      </div>
      <div class="col center">
        <img src="./../../public/imgs/logos/DentsuLogo.png" class="img_logo_client" />
      </div>
       <div class="col center">
        <img src="./../../public/imgs/logos/EssenceAgencyLogo.png" class="img_logo_client" />
      </div>
    </div>

    <div class="row">
      <div class="col center">
        <img src="./../../public/imgs/logos/initiativeLogo.png" class="img_logo_client" />
      </div>
      <div class="col center">
        <img src="./../../public/imgs/logos/UMLogo.png" class="img_logo_client" />
      </div>
      <div class="col center">
        <img src="./../../public/imgs/logos/GrupoWELogo.png" class="img_logo_client" />
      </div>
      <div class="col center">
        <img src="./../../public/imgs/logos/MullenLoweLogo.png" class="img_logo_client" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ClientesComponent'
}
</script>

<style>
.img_logo_client {
  max-width: 11rem;
}

@media (max-width: 600px) {
  .img_line {
    width: 80vw;
  }
}
</style>
